export default __webpack_public_path__ + "static/media/van-gogh-imaging.5f7a7999.png";